import { DataModel } from '../../dto/data-model.js';
import { TicketTemplate } from '../ticket-template/ticket-template';
import { ITicketPoolSeatingModule } from './ticket-pool-seating-module.js';
import { TicketPoolStrategy } from './ticket-pool-strategy.js';

export abstract class ITicketPool extends DataModel {
  public abstract getSeatingModule(): ITicketPoolSeatingModule | null;

  public abstract get strategy(): TicketPoolStrategy;

  public abstract getTicketCount(templateId: string): number;
  public abstract isSoldOut(template: TicketTemplate): boolean;
}
